var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnerNodeImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5937 11.3263L25.3189 16.7635C24.2263 21.4593 22.067 23.3584 18.0086 22.9682C17.3582 22.9162 16.6558 22.7991 15.9013 22.617L13.716 22.0967C8.29174 20.8089 6.61374 18.1293 7.8885 12.6921L9.16326 7.24183C9.42342 6.13617 9.7356 5.1736 10.1258 4.38012C11.6478 1.23224 14.2363 0.386741 18.5809 1.41435L20.7532 1.92166C26.2035 3.19642 27.8684 5.88902 26.5937 11.3263Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0063 22.9709C17.1998 23.5172 16.1852 23.9725 14.9495 24.3757L12.8943 25.0521C7.73023 26.7171 5.01161 25.3253 3.33361 20.1612L1.66862 15.0232C0.0036227 9.85908 1.38244 7.12745 6.54652 5.46246L8.60175 4.78605C9.13507 4.61695 9.64237 4.47387 10.1237 4.38281C9.73343 5.17629 9.42124 6.13886 9.16108 7.24452L7.88632 12.6948C6.61156 18.132 8.28956 20.8116 13.7137 22.0994L15.8991 22.6197C16.6535 22.8018 17.3559 22.9189 18.0063 22.9709Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.8594 8.83984L21.1681 10.4398",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.582 13.875L17.3543 14.8376",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerNodeImg);
export default __webpack_public_path__ + "static/media/partner_node_img.6d6744c24b034c6879384403ce5984c4.svg";
export { ForwardRef as ReactComponent };